export default class Geo { // Geometrics (static methods only)
  static radiansToDegrees (angle) {
    return angle / Math.PI * 180
  }

  static degreesToRadians (angle) {
    return angle / 180 * Math.PI
  }

  static cartesianToPolar ({ x, y }) {
    const radius = Math.sqrt(x * x + y * y)
    const angle = Geo.angle360(90 - Geo.radiansToDegrees(Math.atan2(-y, x)))
    // console.log('cartesianToPolar', {x, y}, '->', {radius, angle})
    return { radius, angle }
  }

  static polarToCartesian ({ radius, angle }) {
    const x = Math.round(10 * radius * Math.sin(Geo.degreesToRadians(angle))) / 10
    const y = -Math.round(10 * radius * Math.cos(Geo.degreesToRadians(angle))) / 10
    // console.log('polarToCartesian', {radius, angle}, '->', {x, y})
    return { x, y }
  }

  static rotatePoint (point, rotation) {
    const { radius, angle } = Geo.cartesianToPolar(point)
    const rotated = { radius, angle: Geo.angle360(angle + rotation) }
    return Geo.polarToCartesian(rotated)
  }

  static calcAngle (point0, point1) {
    const dX = point1[0] - point0[0]
    const dY = point1[1] - point0[1]

    let angle = null
    if (dY < 0) {
      angle = Geo.radiansToDegrees(Math.atan(dX / -dY))
      if (angle < 0) {
        angle = angle + 360
      }
    } else if (dY > 0) {
      angle = Geo.radiansToDegrees(Math.atan(dX / -dY)) + 180
    } else if (dY === 0) {
      if (dX > 0) {
        angle = 90
      } else if (dX < 0) {
        angle = 270
      } else {
        // rotator is in the center
        angle = 0
      }
    }
    return angle
  }

  static calcAngledPosition ([x, y], distance, angle) { // [0, 0], 40, 180 (returns [x1, y1])
    // Returns position of the point located at certain distance and angle from the center
    const diff = Geo.polarToCartesian({ radius: distance, angle })
    return [x + diff.x, y + diff.y]
  }

  static get majorGridSpan () {
    return 8
  }

  static calculateCurrentGridSpan (span, zoomLevel, detailed = true) {
    return Math.max(1, (detailed ? 1 : this.majorGridSpan) * span / zoomLevel)
  }

  static snapPointsToGrid (points, span, zoomLevel) {
    const currentGridSpan = Geo.calculateCurrentGridSpan(span, zoomLevel)
    return points.map(p => Math.round(p / currentGridSpan) * currentGridSpan)
  }

  static getPairedPoints (points) {
    return points.reduce(function (result, value, index, array) {
      if (index % 2 === 0) {
        result.push(array.slice(index, index + 2))
      }
      return result
    }, [])
  }

  static getFlatPoints (pairedPoints) {
    return pairedPoints.reduce((points, anchorPoint) => {
      return [...points, ...anchorPoint]
    }, [])
  }

  // Returns points surrounding a vector by the given dist offset
  // Used for nicer tc_vector
  // QFIX: Now only working for 2-points vectors
  static getStrokePoints (points, dist = 10) {
    const ppoints = Geo.getPairedPoints(points)
    if (ppoints.length === 2) {
      // offset angle (vector angle -90deg)
      const angle = Geo.angle360(Geo.calcAngle(...ppoints) - 90)
      const strokePairedPoints = ppoints.reduce((result, ppoint) => {
        const point0 = Geo.calcAngledPosition(ppoint, dist, angle)
        const point1 = Geo.calcAngledPosition(ppoint, dist, Geo.angle360(angle + 180))
        return [point1, ...result, point0]
      }, [])
      return Geo.getFlatPoints(strokePairedPoints)
    }
    console.warn('[tc][getStrokePoints]', { points: points })
    return []
  }

  static angle360 (val) {
    // Returns angle on the range [0 - 360)
    return val >= 0 ? val % 360 : val % 360 + 360
  }
}
